"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNativeWeb = require("react-native-web");

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _AaPassengerRoomSelection = require("./AaPassengerRoomSelection.model");

var _AaPassengerRoomSelection2 = _interopRequireDefault(require("./AaPassengerRoomSelection.styles"));

var _helpers = require("./helpers");

var TextSummary = function TextSummary(props) {
  var renderLabel = function renderLabel(label) {
    var roomOccupancy = props.data;
    var labelText = (0, _helpers.getGuestText)(roomOccupancy, props.translation, label);
    return labelText ? /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
      style: _AaPassengerRoomSelection2["default"].labelPassenger
    }, ", ".concat(labelText)) : null;
  };

  var roomCount = props.data.length;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: {
      alignItems: 'center',
      flexDirection: 'row'
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: _AaPassengerRoomSelection2["default"].labelPassenger
  }, props.translation.paxRoomLabel && props.translation.paxRoomLabel.replace("{0}", roomCount)), renderLabel(_AaPassengerRoomSelection.PASSENGER_TYPE.ADULT), renderLabel(_AaPassengerRoomSelection.PASSENGER_TYPE.CHILD), renderLabel(_AaPassengerRoomSelection.PASSENGER_TYPE.INFANT)), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: _AaPassengerRoomSelection2["default"].textInputIcon
  }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaIconComponent, {
    controls: {
      iconName: _crossPlatformComponents.AaIconTypes.ARROW_DROPDOWN,
      iconStyle: {
        height: 24,
        width: 24
      }
    }
  })));
};

var _default = TextSummary;
exports["default"] = _default;